var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKeyboardArrowRight24Px = function SvgKeyboardArrowRight24Px(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00001 9.875L4.88001 5.995L1.00001 2.115C0.812752 1.92817 0.70752 1.67452 0.70752 1.41C0.70752 1.14548 0.812752 0.89183 1.00001 0.704998C1.39001 0.314998 2.02001 0.314998 2.41001 0.704998L7.00001 5.295C7.39001 5.685 7.39001 6.315 7.00001 6.705L2.41001 11.295C2.02001 11.685 1.39001 11.685 1.00001 11.295C0.620005 10.905 0.610005 10.265 1.00001 9.875Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKeyboardArrowRight24Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "keyboard_arrow_right_24px.f186b8a8a436aa188f56a99bafdc556a.svg";